import * as api from "../../../redux/api/actions.js";

import Autocomplete, {
  autocompleteDefaultOnChange,
  autocompleteDefaultOnChangeSavingID,
} from "../../../components/material/Autocomplete";
import Button, { COLORS } from "../../../components/material/Button";
import { ESTADOS, ESTADOS_E_CIDADES } from "../../../utils/constants";
import { IconButton, InputAdornment } from "@material-ui/core";
import React, { Component } from "react";
import TextField, {
  textfieldDefaultOnChange,
} from "../../../components/material/TextField";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import {
  findEstado,
  missingRequiredFieldChecker,
  requiredFieldsEvaluator,
} from "./../../../utils/formHelper";

import _ from "lodash";
import { connect } from "react-redux";
import track from "react-tracking";
import { withPropsFromDatabase } from "../../../database/resources/utils";

const PRE_REGISTER_ROLES = [
  { id: "a8454122-2d9a-4cea-b610-e76163cd7774", name: "Veterinario" },
  {
    id: "adb7f205-7d82-4b5c-91f8-8e4bc8a6fa3a",
    name: "Cliente (somente visualização)",
  },
  { id: "92aa6422-c4b3-4d52-aa43-7d5ef7bfa7f1", name: "Estagiário" },
  { id: "9c13e4c0-c204-4be7-9381-caa97afb3c3b", name: "Inseminador" },
];

@track(() => ({ page: "Pre-registro de Usuários Form", date: new Date() }))
class PreRegisterUserForm extends Component {
  constructor(props) {
    super(props);

    console.log("🔍 PreRegisterUserForm - constructor:");
    console.log("  - props.initialValues:", props.initialValues);
    console.log(
      "  - props.initialValues.zoetisId:",
      props.initialValues?.zoetisId,
    );

    this.state = {
      ...props.initialValues,
      loading: false,
      emailValidating: false,
      emailError: "",
      showPassword: false,
      showConfirmPassword: false,
      password: "Progerar@2026",
      confirmPassword: "Progerar@2026",
    };

    this.missingRequiredFieldChecker = missingRequiredFieldChecker.bind(this);
    this.requiredFieldsEvaluator = requiredFieldsEvaluator.bind(this);
    this.autocompleteDefaultOnChange = autocompleteDefaultOnChange.bind(this);
    this.textfieldDefaultOnChange = textfieldDefaultOnChange.bind(this);
    this.autocompleteDefaultOnChangeSavingID =
      autocompleteDefaultOnChangeSavingID.bind(this);

    this.onCancel = this.onCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
    this.handleClickShowConfirmPassword =
      this.handleClickShowConfirmPassword.bind(this);
  }

  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  handleClickShowConfirmPassword() {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  }

  onCancel() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  onEnterPress = (e) => {
    if (e.key === "Enter" && e.shiftKey === false) {
      e.preventDefault();
      this.onSubmit();
    }
  };

  validateEmail = async () => {
    this.setState({ emailValidating: true, emailError: "" });
    try {
      const result = await api.get(
        this.props.dispatch,
        "users",
        `Account/VerifyEmail/${this.state.email}`,
      );
      if (result.hasErrors) {
        this.setState({ emailError: result.title });
      }
    } catch (error) {
      this.setState({ emailError: "Erro ao validar o e-mail." });
    } finally {
      this.setState({ emailValidating: false });
    }
  };

  @track((props, state) =>
    state.id
      ? { action: "Editou um pré-registro", value: state.id }
      : { action: "Criou um novo pré-registro", value: state.nome },
  )
  async onSubmit() {
    this.setState({ loading: true });
    await this.validateEmail();
    let requiredFieldsState = this.requiredFieldsEvaluator();
    if (
      requiredFieldsState !== null ||
      this.state.nome == null ||
      this.state.sobrenome == null ||
      this.state.email == null ||
      this.state.password == null ||
      this.state.confirmPassword == null ||
      this.state.estado == null ||
      this.state.municipio == null ||
      this.state.zoetisId == null ||
      this.state.role == null ||
      !_.isEmpty(this.state.emailError)
    ) {
      this.setState(requiredFieldsState);
    } else if (this.state.password !== this.state.confirmPassword) {
      this.setState({
        password_error: "As senhas não conferem",
        confirmPassword_error: "As senhas não conferem",
      });
    } else {
      let payload = {
        ..._.pick(this.state, [
          "nome",
          "sobrenome",
          "email",
          "password",
          "municipio",
          "zoetisId",
          "role",
        ]),
        estado: findEstado(this.state.estado).name,
      };

      if (this.props.onSubmit) {
        this.props.onSubmit(payload);
      }
    }

    this.setState({ loading: false });
  }

  render() {
    return (
      <div className="grid app-preregister-form">
        <div className="p-12 t-6 d-6 p-margin-top-2 grid-item">
          <TextField
            id="nome"
            label="Nome"
            onChange={this.textfieldDefaultOnChange}
            onKeyDown={this.onEnterPress}
            value={this.state.nome || ""}
            error={!_.isEmpty(this.state.nome_error)}
            helperText={this.state.nome_error}
            autoFocus
          />
        </div>
        <div className="p-12 t-6 d-6 p-margin-top-2 grid-item">
          <TextField
            id="sobrenome"
            label="Sobrenome"
            onChange={this.textfieldDefaultOnChange}
            onKeyDown={this.onEnterPress}
            value={this.state.sobrenome || ""}
            error={!_.isEmpty(this.state.sobrenome_error)}
            helperText={this.state.sobrenome_error}
          />
        </div>
        <div className="p-12 t-12 d-12 p-margin-top-2 grid-item">
          <TextField
            id="email"
            label="E-mail"
            onChange={this.textfieldDefaultOnChange}
            onKeyDown={this.onEnterPress}
            onBlur={this.validateEmail}
            type="email"
            value={this.state.email || ""}
            error={
              !_.isEmpty(this.state.email_error) ||
              !_.isEmpty(this.state.emailError)
            }
            helperText={this.state.email_error || this.state.emailError}
            disabled={this.state.emailValidating}
          />
        </div>
        <div className="p-12 t-6 d-6 p-margin-top-2 grid-item">
          <TextField
            id="password"
            label="Senha Temporária"
            onChange={this.textfieldDefaultOnChange}
            onKeyDown={this.onEnterPress}
            type={this.state.showPassword ? "text" : "password"}
            value={this.state.password || ""}
            error={!_.isEmpty(this.state.password_error)}
            helperText={this.state.password_error}
            disabled={true}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={this.handleClickShowPassword}
                  >
                    {this.state.showPassword ? (
                      <Visibility />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="p-12 t-6 d-6 p-margin-top-2 grid-item">
          <TextField
            id="confirmPassword"
            label="Confirmar Senha Temporária"
            onChange={this.textfieldDefaultOnChange}
            onKeyDown={this.onEnterPress}
            type={this.state.showConfirmPassword ? "text" : "password"}
            value={this.state.confirmPassword || ""}
            error={!_.isEmpty(this.state.confirmPassword_error)}
            helperText={this.state.confirmPassword_error}
            disabled={true}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={this.handleClickShowConfirmPassword}
                  >
                    {this.state.showConfirmPassword ? (
                      <Visibility />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="p-12 t-4 d-4 p-margin-top-2 grid-item">
          <Autocomplete
            id="estado"
            options={ESTADOS}
            onChange={this.autocompleteDefaultOnChangeSavingID("estado")}
            onKeyDown={this.state.estado && this.onEnterPress}
            getOptionLabel={(option) => {
              if (_.has(option, "name")) {
                return option.name;
              }
              const opt = findEstado(option);
              return (opt && opt.name) || "";
            }}
            useDefaultOptionSelected
            label="Estado"
            value={this.state.estado || ""}
            error={!_.isEmpty(this.state.estado_error)}
            helperText={this.state.estado_error}
          />
        </div>
        <div className="p-12 t-8 d-4 p-margin-top-2 grid-item">
          <Autocomplete
            id="municipio"
            label="Município"
            options={
              this.state.estado
                ? ESTADOS_E_CIDADES.filter(
                    (e) =>
                      e.name === this.state.estado ||
                      e.id === this.state.estado,
                  )[0].cidades
                : []
            }
            disabled={!this.state.estado}
            onChange={this.autocompleteDefaultOnChange("municipio")}
            onKeyDown={this.onEnterPress}
            value={this.state.municipio}
            error={!_.isEmpty(this.state.municipio_error)}
            helperText={this.state.municipio_error}
          />
        </div>
        <div className="p-12 t-12 d-4 p-margin-top-2 grid-item">
          <TextField
            id="zoetisId"
            label="Zoetis ID (ou DMR ID)"
            onChange={this.textfieldDefaultOnChange}
            onKeyDown={this.onEnterPress}
            value={this.state.zoetisId || ""}
            error={!_.isEmpty(this.state.zoetisId_error)}
            helperText={this.state.zoetisId_error}
          />
        </div>
        <div className="p-12 d-4 p-margin-top-2 grid-item">
          <Autocomplete
            id="role"
            options={PRE_REGISTER_ROLES}
            onChange={this.autocompleteDefaultOnChangeSavingID("role")}
            onKeyDown={this.state.role && this.onEnterPress}
            getOptionLabel={(option) => {
              if (_.has(option, "name")) {
                return option.name;
              }
              const opt = _.find(PRE_REGISTER_ROLES, { id: option });
              return (opt && opt.name) || "";
            }}
            useDefaultOptionSelected
            label="Perfil"
            value={this.state.role || ""}
            error={!_.isEmpty(this.state.role_error)}
            helperText={this.state.role_error}
          />
        </div>

        <div className="p-12 p-margin-top-2 p-display-flex p-justify-space-between grid-item">
          <Button
            color={COLORS.GREY}
            label="Cancelar"
            onClick={this.onCancel}
          />
          <Button
            label="Salvar"
            disabled={this.props.loading || this.state.loading}
            onClick={this.onSubmit}
          />
        </div>
      </div>
    );
  }
}

const propsFromDatabase = async (props) => {
  return {
    requiredFields: [
      "nome",
      "sobrenome",
      "email",
      "password",
      "confirmPassword",
      "estado",
      "municipio",
      "zoetisId",
      "role",
    ],
  };
};

export default connect()(
  withPropsFromDatabase(propsFromDatabase, PreRegisterUserForm),
);
